import { Icons } from "atoms/constants/icons";
import { ParagraphSizes } from "atoms/constants/paragraph-sizes";
import Icon from "atoms/icons/icon";
import Paragraph from "atoms/typography/paragraph";
import React from "react";
import { t } from "utilities/localization-utils";

const CSS_CLASS_NAME = "c-chat-memories-modal";

interface MaxMemoriesAlertProps {
    memoryCount: number;
    maxMemories: number;
}

const MaxMemoriesAlert = ({
    memoryCount,
    maxMemories,
}: MaxMemoriesAlertProps) => {
    return (
        <div className={`${CSS_CLASS_NAME}__limit-alert`}>
            <Icon
                type={Icons.Warning}
                cssClassName={`${CSS_CLASS_NAME}__limit-alert-icon`}
            />
            <div>
                <Paragraph
                    cssClassName={`${CSS_CLASS_NAME}__limit-alert-title`}>
                    {memoryCount === maxMemories - 1
                        ? t("chat-memories-modal--near-limit-title", {
                              count: memoryCount,
                              total: maxMemories,
                          })
                        : t("chat-memories-modal--limit-reached-title")}
                </Paragraph>
                <Paragraph
                    cssClassName={`${CSS_CLASS_NAME}__limit-alert-message`}
                    size={ParagraphSizes.Small}>
                    {memoryCount === maxMemories - 1
                        ? t("chat-memories-modal--near-limit-message", {
                              remainingSlots: maxMemories - memoryCount,
                          })
                        : t("chat-memories-modal--limit-reached-message")}
                </Paragraph>
            </div>
        </div>
    );
};

export default MaxMemoriesAlert;
